import product1 from "./assets/products/1.jpg";
import product2 from "./assets/products/2.jpeg";
import product3 from "./assets/products/3.jpeg";
import product4 from "./assets/products/4.jpg";
import product5 from "./assets/products/5.jpg";
import product6 from "./assets/products/6.png";
import product7 from "./assets/products/7.png";
import product8 from "./assets/products/8.jpg";

export const PRODUCTS = [
  {
    id: 1,
    productName: "Blue Yeti Microphone (Blackout Edition)",
    price: 999.0,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Xiaomi Haylou GST Smart Watch (LS09B)",
    price: 1999.0,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Xiaomi Solove F5 4000mAh Rechargeable Desk Fan",
    price: 699.0,
    productImage: product3,
  },
  {
    id: 4,
    productName: "JISULIFE FA20 Rechargeable Mini Handheld Fan",
    price:  990,
    productImage: product4,
  },
  {
    id: 5,
    productName: "Bluetooth Selfie Remote Shutter",
    price: 19.99,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Havells ERA DRY IRON 1000W",
    price: 68.0,
    productImage: product6,
  },
  {
    id: 7,
    productName: "G7 Bluetooth Neckband With Magnetic Headsets",
    price: 120.0,
    productImage: product7,
  },
  {
    id: 8,
    productName: "BOYA MM1 Microphone",
    price: 40.0,
    productImage: product8,
  },
];
